<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <h2>Welcome {{ user.name }}</h2>
        </v-col>
        <v-col class="col-6 col-sm-6 col-mb-4 col-lg-4">
          <v-card
            @click="viewAllAgencies()"
            color="primary"
            dark
            flat
            class="px-3 py-3"
          >
            <v-row>
              <v-col class="col-12 danetest--text"> All Agencies </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large>mdi-home-modern</v-icon>
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>
                  {{ allAcgencies.length }}
                </h1>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col class="col-6 col-sm-6 col-mb-4 col-lg-4">
          <v-card color="compeatsecondary" dark flat class="px-3 py-3">
            <v-row>
              <v-col class="col-12 danetest--text"> All Resellers </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large>mdi-account-key</v-icon>
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>0</h1>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col class="col-6 col-sm-6 col-mb-4 col-lg-4">
          <v-card color="compeatthird" dark flat class="px-3 py-3">
            <v-row>
              <v-col class="col-12 danetest--text"> All Subscribers </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large
                  >mdi-account-multiple</v-icon
                >
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>{{ allSubscribers.length }}</h1>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col class="col-6 col-sm-6 col-mb-4 col-lg-4">
          <v-card
            @click="viewAllSubscriptions()"
            color="primary"
            dark
            flat
            class="px-3 py-3"
          >
            <v-row>
              <v-col class="col-12 danetest--text"> All Subscriptions </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large>mdi-note-multiple</v-icon>
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>
                  {{ allSubscriptions.length }}
                </h1>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col class="col-6 col-sm-6 col-mb-4 col-lg-4">
          <v-card color="compeatsecondary" dark flat class="px-3 py-3">
            <v-row>
              <v-col class="col-12 danetest--text"> All Demo Reports </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large>mdi-note-multiple</v-icon>
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>
                  {{ allDemoReports.length }}
                </h1>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col class="col-6 col-sm-6 col-mb-4 col-lg-4">
          <v-card color="compeatthird" dark flat class="px-3 py-3">
            <v-row>
              <v-col class="col-12 danetest--text">
                All Cancelled Subscriptions
              </v-col>
              <v-col class="col-3">
                <v-icon class="danetest--text" large>mdi-note-multiple</v-icon>
              </v-col>
              <v-col class="col-9 text-right danetest--text">
                <h1>
                  {{ allCancelledSubscriptions.length }}
                </h1>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="8">
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="8">
                  <h2>
                    Last {{ this.selectedDays }} Subscriptions And Demo Reports
                  </h2>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-select
                    outlined
                    :items="selectDays"
                    label="Select Number of Days"
                    v-model="selectedDays"
                    @change="handleDaysSelection"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <apexchart
                    type="line"
                    :options="options"
                    :series="series"
                    height="400px"
                  ></apexchart>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4" class="text-center">
          <v-card class="mb-3">
            <v-card-text>
              <v-row>
                <v-col cols="5" class="text-left">
                  <h2>Total Sales</h2>
                </v-col>
                <v-col cols="7" class="text-right">
                  <h2>$ {{ this.totalPrice | formatTotalAmount }}</h2>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-text>
              <h2>Leader Board Sales</h2>
              <v-list>
                <v-list-item v-for="agency in allAcgencies" :key="agency.id">
                  {{ agency.agencyName }} <v-spacer></v-spacer>
                  {{ agency.subscriptionCount }}
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-text>
              <h2>Package Purchased Ratio</h2>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsPackages"
                :series="seriesPackages"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120"
        >Please Wait...</v-progress-circular
      >
    </v-overlay>
  </div>
</template>

<script>
import { firebaseApp } from "../../firebaseConfig";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default {
  props: ["uid", "user"],
  data: () => ({
    allAcgencies: [],
    allSubscriptions: [],
    allDemoReports: [],
    allCancelledSubscriptions: [],
    overlay: false,
    allSubscribers: [],
    options: {},
    series: [],
    selectDays: ["7 Days", "14 Days"],
    selectedDays: "7 Days",
    allSubscriptionsCount: [],
    totalPrice: 0,
    seriesPackages: [],
    chartOptionsPackages: {},
  }),
  created() {
    this.getallAgencies();
  },
  filters: {
    formatTotalAmount: function (value) {
      if (!value) return "";
      return new Intl.NumberFormat("en-ZA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
  },
  methods: {
    async getallAgencies() {
      try {
        this.overlay = true;
        const querySnapshot = await getDocs(collection(db, "agencies"));

        // Clear the array before filling it with new data
        this.allAcgencies = [];

        const agencyPromises = querySnapshot.docs.map(async (doc) => {
          let agency = doc.data();
          agency.id = doc.id; // Store the agency ID

          // Count subscriptions for this agency
          agency.subscriptionCount = await this.countSubscriptionsForAgency(
            doc.id
          );

          this.allAcgencies.push(agency);
        });

        // Wait for all agency promises to resolve
        await Promise.all(agencyPromises);

        console.log(this.allAcgencies), this.allAcgencies;

        this.getallSubscriptions();
      } catch (err) {
        console.log("getallAgencies err", err);
      }
    },
    async countSubscriptionsForAgency(agencyId) {
      try {
        const querySnapshot = await getDocs(
          query(
            collection(db, "subscriptions"),
            where("agencyId", "==", agencyId)
          )
        );
        return querySnapshot.size;
      } catch (err) {
        console.log("countSubscriptionsForAgency err", err);
        return 0;
      }
    },
    async getallSubscriptions() {
      try {
        const querySnapshot = await getDocs(collection(db, "subscriptions"));
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, " => ", doc.data());
          let subscription = doc.data();
          this.totalPrice += subscription.package.priceTotal;
          this.allSubscriptions.push(subscription);
        });
        const [headings, counts] = await this.processSubscriptions(
          this.allSubscriptions
        );

        this.seriesPackages = counts;
        this.chartOptionsPackages = {
          labels: headings,
          dataLabels: {
            enabled: false,
          },
          responsive: [
            {
              breakpoint: 960,
              options: {
                chart: {
                  width: 290,
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
          legend: {
            position: "bottom",
          },
        };

        this.getallDemoReports();
      } catch (err) {
        console.log("getallSubscriptions err", err);
      }
    },
    async processSubscriptions(subscriptions) {
      const packageCounts = {};

      subscriptions.forEach((subscription) => {
        const currentPackage = subscription.package.currentPackage;
        if (currentPackage) {
          if (packageCounts[currentPackage]) {
            packageCounts[currentPackage]++;
          } else {
            packageCounts[currentPackage] = 1;
          }
        }
      });

      const headings = Object.keys(packageCounts);
      const counts = Object.values(packageCounts);

      return [headings, counts];
    },
    async getallDemoReports() {
      try {
        const querySnapshot = await getDocs(collection(db, "demoreports"));
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          let report = doc.data();
          this.allDemoReports.push(report);
        });
        this.getallCancelledSubscriptions();
      } catch (err) {
        console.log("getallDemoReports err", err);
      }
    },
    async getallCancelledSubscriptions() {
      try {
        const querySnapshot = await getDocs(
          collection(db, "cancelledsubscriptions")
        );
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          let report = doc.data();
          this.allCancelledSubscriptions.push(report);
        });
        this.handleDaysSelection();
        this.getAllSubscribers();
      } catch (err) {
        console.log("getallCancelledSubscriptions err", err);
      }
    },
    async handleDaysSelection() {
      const numDays = parseInt(this.selectedDays);
      console.log("numDays", numDays);
      const result = await this.processReportDates(
        numDays,
        this.allSubscriptions,
        "dateCreated"
      );
      const result2 = await this.processReportDates(
        numDays,
        this.allDemoReports,
        "createdAt"
      );
      const result3 = await this.processReportDates(
        numDays,
        this.allCancelledSubscriptions,
        "dateCancelled"
      );

      this.options = {
        chart: {
          id: "vuechart-example",
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: result.reportDates,
        },
      };
      this.series = [
        {
          name: "Subscriptions",
          data: result.reportCounts,
        },
        {
          name: "Cancelled Subscriptions",
          data: result3.reportCounts,
        },
        {
          name: "Demo Reports",
          data: result2.reportCounts,
        },
      ];

      console.log("result", result);
      console.log("result2", result2);
      // return result;
    },
    async processReportDates(numDays, data, dateName) {
      const currentDate = new Date();
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(currentDate.getDate() - numDays);

      const reportDates = []; // Array to store dates
      const reportCounts = []; // Array to store counts

      const reportCountsPerDay = {};

      data.forEach((item) => {
        // subscription.reports.forEach((report) => {
        const reportDate = new Date(item[dateName]); // Assuming 'date' is the report date field

        if (reportDate >= oneWeekAgo && reportDate <= currentDate) {
          const formattedDate = reportDate.toISOString().split("T")[0];
          if (!reportCountsPerDay[formattedDate]) {
            reportCountsPerDay[formattedDate] = 0;
          }
          reportCountsPerDay[formattedDate]++;
        }
        // });
      });

      // Populate the arrays with dates and counts
      for (
        let date = oneWeekAgo;
        date <= currentDate;
        date.setDate(date.getDate() + 1)
      ) {
        const formattedDate = date.toISOString().split("T")[0];
        reportDates.push(formattedDate);
        reportCounts.push(reportCountsPerDay[formattedDate] || 0);
      }
      // this.options.xaxis.categories = reportDates;
      console.log(reportDates, reportCounts, reportCountsPerDay);

      return {
        reportDates: reportDates,
        reportCounts: reportCounts,
        reportCountsPerDay: reportCountsPerDay,
      };
    },
    async getAllSubscribers() {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data());
          let user = doc.data();
          if (user.userType == "SB") {
            this.allSubscribers.push(user);
          }
        });

        console.log("this.allSubscribers", this.allSubscribers);

        this.overlay = false;
      } catch (err) {
        console.log("getallDemoReports err", err);
      }
    },
    viewAllAgencies() {
      this.$router.push({
        name: "agencies",
      });
    },
    viewAllSubscriptions() {
      this.$router.push({
        name: "agencySubscriptions",
      });
    },
  },
};
</script>
